module.exports = __webpack_public_path__ + "static/img/full_line_shape.572f2094.png";